import { isDev, isStaging } from "../utils/general"

export const DefaultAgentId = "defaultAgent"
export const DefaultAgentCreatorId = "felix"

export enum AuthMode {
  LOGIN = "login",
  SIGNUP = "signup",
}

export const STRIPE_CONFIG = {
  PROMO_CODES: {
    CUSTOMER_FACING: "PKAJ2HG0",
    STRIPE_ID: {
      DEVELOPMENT: "promo_1S5RTG2MW3vXJI7riUc8WueU",
      STAGING: "promo_1S5RTG2MW3vXJI7riUc8WueU",
      PRODUCTION: "promo_1S4rSl2MW3vXJI7r62ysKNqJ",
    },
  },
  PRODUCT_IDS: {
    HERO_PROMO_PLAN: {
      DEVELOPMENT: "prod_SjWer9rACFrNOg",
      STAGING: "prod_SjWer9rACFrNOg",
      PRODUCTION: "prod_QmWJdOMvg5HBJQ",
    },
  },
  PLAN_NAME: "Starter",
}

export const getStripePromoId = (): string => {
  if (isDev) {
    return STRIPE_CONFIG.PROMO_CODES.STRIPE_ID.DEVELOPMENT
  } else if (isStaging) {
    return STRIPE_CONFIG.PROMO_CODES.STRIPE_ID.STAGING
  } else {
    return STRIPE_CONFIG.PROMO_CODES.STRIPE_ID.PRODUCTION
  }
}

export const getHeroPromoProductId = (): string => {
  if (isDev) {
    return STRIPE_CONFIG.PRODUCT_IDS.HERO_PROMO_PLAN.DEVELOPMENT
  } else if (isStaging) {
    return STRIPE_CONFIG.PRODUCT_IDS.HERO_PROMO_PLAN.STAGING
  } else {
    return STRIPE_CONFIG.PRODUCT_IDS.HERO_PROMO_PLAN.PRODUCTION
  }
}
